import "./Homescreen/Login.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import NavbarLogin from "./NavbarLogin";
import axios from "axios";

function Signin() {
    
    const [loginId, setLoginId] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            // Send login credentials to backend
            //const response = await axios.post("http://localhost:8000/api/login", {
            const response = await axios.post("https://alphabeta4success.com/api/login", {
                username: loginId,
                password: password
            });

            if (response.data.success) {
                // Store token or user info in sessionStorage
                sessionStorage.setItem("token", response.data.token);
                sessionStorage.setItem("userId", response.data.user.id);
                sessionStorage.setItem("userType", response.data.user.type);
                sessionStorage.setItem("username", response.data.user.username);
                //alert(sessionStorage.getItem("username"));
                const userType = sessionStorage.getItem("userType");
                
                if(userType === "Admin"){                    
                    navigate("/AdminDashboard");
                }
                if(userType === "Tutor"){                    
                    navigate("/TutorDashboard");
                }
                if(userType === "Student"){                    
                    navigate("/StudentDashboard");
                }
                } else {
                setError(response.data.message || "Invalid login credentials");
                alert("Invalid login credentials. If you are new user, please register.");
            }
        } catch (err) {
            setError("Login failed. Please try again.");
            console.error(err);
        }
    };

    return (
        <>
            <NavbarLogin />
            <div className="form_wrapper">
                <div className="form_container">
                    <div className="title_container">
                        <h2>Login Form</h2>
                    </div>
                    <form onSubmit={handleLogin} className="row clearfix">
                        <div className="input_field">
                            <span><i aria-hidden="true" className="fa fa-user"></i></span>
                            <input
                                type="text"
                                name="loginid"
                                placeholder="Login ID"
                                required
                                value={loginId}
                                onChange={(e) => setLoginId(e.target.value)}
                            />
                        </div>

                        <div className="input_field">
                            <span><i aria-hidden="true" className="fa fa-lock"></i></span>
                            <input
                                type="password"
                                name="Password"
                                placeholder="Password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>

                        {error && <p className="error" style={{ color: "red" }}>{error}</p>}

                        <div className="input_field">
                            <input
                                className="button"
                                type="submit"
                                value="Login"
                            />  
                            <h2 align="center" className="or"> OR </h2>
                            <h2><p align="center">
                                Don't have an account? <Link to="/Login"> Please Register </Link>
                            </p></h2>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default Signin;
